import { UnlimThreeStatus } from 'constants/accumulators';

import { ReplenishButtonType } from '../utils';

export const enum AccumUnit {
  KBYTE = 'KBYTE',
  SECONDS = 'SECONDS',
  SMS = 'SMS',
  MINUTES = 'MINUTES',
  MMS = 'MMS',
  'SMS/MMS' = 'SMS/MMS',
}

export type AccumServiceType = {
  tethering?: TetheringType;
  unlimited3?: UnlimitedThreeHours;
  unlimited24?: UnlimitedDayType;
};

export type TetheringType = {
  description?: string;
  tetheringProActive: boolean;
  tetheringProExpiration?: string;
  tetheringProMode: string;
};

export type UnlimitedThreeHours = {
  expirationDate?: string;
  status: UnlimThreeStatus;
};

export type UnlimitedDayType = {
  expirationDate?: string;
  progressBarLimits?: string;
};

export type AccumItemType = {
  baseRest?: number;
  description?: string;
  isGiftBucket?: boolean;
  isLow?: boolean;
  isShowReplenishButton?: boolean;
  isUnlimited?: boolean;
  progressBarLimits?: string;
  replenishButtonType?: ReplenishButtonType;
  resetDate?: string;
  resetDateTimeUtc?: string;
  rest: number;
  size?: number;
  socType?: string;
  title?: string;
  unit: `${AccumUnit}`;
};

export type EnrichedAccumItemType = {
  displayUnit?: string;
  isLowTethering?: boolean;
  sizeText?: string;
  tetheringRest?: number;
  tetheringSize?: number;
} & AccumItemType;

export type AccumulatorType = {
  isForYoung?: boolean; // SvyazZ
  isShowProgress: boolean;
  isShowReplenishButton?: boolean;
  isTariffZv2?: boolean; // Простой тариф
  items: AccumItemType[];
  mainCtn?: string;
  services?: AccumServiceType;
  tariffUrl?: string;
  tetheringIsLow?: boolean;
};

export type AccumulatorsInfoType = {
  accumulators: AccumulatorType;
  sharing: SharingType;
};

export type SharingChildType = {
  ctn: string;
  name: string;
  roleId?: string;
};

export type SharingType = {
  children?: SharingChildType[];
  parentInfo?: SharingChildType[];
  rcRate?: number;
  rcRatePeriodDays: number;
  size?: number;
};

export type AccumulatorVariant = 'base' | 'prostoy' | 'svyazZ';

export type UnlimitedAccumulatorVariant =
  | 'Unlimited3HoursActive'
  | 'Unlimited3HoursAvailable'
  | 'Unlimited3HoursCooling'
  | 'Unlimited24Hours'
  | 'UnlimitedBase'
  | 'UnlimitedWithLimitedTethering'
  | 'UnlimitedWithUnlimitedTethering';

export type UnlimitedAccumulatorButtonType =
  | 'GbForDay'
  | 'Replenishment'
  | 'Tethering'
  | 'Unlim3Available'
  | 'Unlim3Cooling';

export type AccumCommonPropsType = {
  additionalBillingInfo?: string;
  className?: string;
  isMobile?: boolean;
};
